import { render } from "./baseSetting.vue?vue&type=template&id=15e992e9"
import script from "./baseSetting.vue?vue&type=script&lang=js"
export * from "./baseSetting.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vue\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__